import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';

const CustomerLinkCell = ({ dataKey, data, permissions }) => <React.Fragment>
  { data && data[dataKey] != null && data[dataKey] > 0 && AccessControl.hasPermission(permissions, [ActivityPerms.customerPageEdit, ActivityPerms.customerPageView])
    && <Link
      to={ `/customer/${ data[dataKey] }` }
      id={ data[dataKey] }
    >
      { `${ data.customerId } - ${ data.customerName }` }
    </Link> }
  { data && data[dataKey] != null && data[dataKey] > 0 && !AccessControl.hasPermission(permissions, [ActivityPerms.customerPageEdit, ActivityPerms.customerPageView])
   && <span>
     { `${ data.customerId } - ${ data.customerName }` }
   </span> }
  { (!data || !data[dataKey] == null || data[dataKey] <= 0) && 'N/A' }
</React.Fragment>;

CustomerLinkCell.propTypes = {
  dataKey: PropTypes.string,
  data: PropTypes.shape(),
  permissions: PropTypes.arrayOf(PropTypes.string)
};

CustomerLinkCell.defaultProps = {
  dataKey: null,
  data: null,
  permissions: null
};

export default CustomerLinkCell;
